// @flow
import alt from '../alt';

import ActiveConfigActions from '../actions/ActiveConfigActions';
import NotificationActions from '../actions/NotificationActions';
import ActiveConfigSource from '../sources/ActiveConfigSource';

import _ from 'underscore';
import t from '../trans';
import rootStore from "./index";

/**
 * Tooteinfo haldamise store
 */
class ActiveConfigStore {
    constructor() {
        this.state = {
            config: {},
            // OK -> PROCESSING -> OK / FAIL
            state: "OK"
        };
        this.bindActions(ActiveConfigActions);
        this.exportAsync(ActiveConfigSource);
    }

    /**
     * Toote laadimise käivitamine
     */
    onFetchConfig() {
        this.setState({state: "PROCESSING"});
        let p = this.getInstance().fetchConfig();
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function () {});
    }

    /**
     * Toote laadimine ebaõnnestus
     */
    onFetchConfigFailed(error) {
        this.processError(error);
    }

    processError(error) {
        let message = t('Server error');
        if (error.response) {
            if (error.response.data && error.response.data.error && error.response.data.error.message) {
                message = error.response.data.error.message;
            }
            else {
                switch (error.response.status) {
                    case 401:
                    case 403:
                        // Authentication required
                        console.log("ActiveConfigStore.processError(): STATUS 401/403: invalidating session");
                        rootStore.sessionStore.invalidate();
                        message = t("Invalid password");
                        break;
                    default:
                        message = t("Server error");
                }
            }
            switch (error.response.status) {
                case 401:
                case 403:
                    // Authentication required
                    console.log("ActiveConfigStore.processError(): STATUS 401/403: invalidating session");
                    rootStore.sessionStore.invalidate();
                    this.setState({state: "FAIL"});
                    break;
                default:
                    this.setState({state: "FAIL"});
            }
        } else {
            this.setState({state: "FAIL"});
        }
        NotificationActions.error.defer(message);
    }

    onFetchConfigDone(response) {
        try {
            if (!_.has(response.data, 'activeConfigurationResult')) throw t("Server error");
            if (response.data.activeConfigurationResult == null) this.setState({config: {}, state: "OK"});
            else this.setState({config: response.data.activeConfigurationResult, state: "OK"});
        } catch (e) {
            if (!_.isString(e)) {
                console.log(e.toString());
                NotificationActions.error.defer(t("Server error"));
            }
            else NotificationActions.error.defer(e);
            this.setState({state: "FAIL"});
        }
    }

}

export default alt.createStore(ActiveConfigStore, 'ActiveConfigStore');
